@use "variables" as *;

.toolbarButton {
  height: fit-content !important;
  align-self: center !important;
}

.loadingIndicator {
  width: $fontSize-xl !important;
  height: $fontSize-xl !important;
}

.span {
  width: 100%;
  height: 100%;
}
